import { render, staticRenderFns } from "./authorization-add.vue?vue&type=template&id=3c196026&"
import script from "./authorization-add.vue?vue&type=script&lang=js&"
export * from "./authorization-add.vue?vue&type=script&lang=js&"
import style0 from "./authorization-add.vue?vue&type=style&index=0&id=3c196026&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports